import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import Icon from '../../../common/icons/Icon';

const CENTER_OF_UNITED_STATES = { lat: 38.371809, lng: -98.613281 };

class GoogleMap extends Component {
  static propTypes = {
    center: PropTypes.object,
    movementSpecialists: PropTypes.array,
    onClickViewProfile: PropTypes.func,
    onClickMarker: PropTypes.func,
    zoom: PropTypes.number,
    cardHoverId: PropTypes.number,
  };

  static defaultProps = {
    center: CENTER_OF_UNITED_STATES,
    zoom: 4,
  };

  state = {
    openBubbleMovementSpecialistId: null,
    isMouseOnMarker: false,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.cardHoverId !== nextProps.cardHoverId) {
      this.displayBubble(nextProps.cardHoverId);
    }
  }

  createMapOptions = () => {
    return {
      styles: [
        { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#444444' }] },
        { featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
        { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 45 }] },
        { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
        { featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', elementType: 'all', stylers: [{ color: '#46bcec' }, { visibility: 'on' }] },
      ],
      scrollwheel: false,
      gestureHandling: 'greedy', // Will capture all touch events on the map towards map panning
    };
  };

  displayBubble(movementSpecialistId, e) {
    this.setState({
      openBubbleMovementSpecialistId: movementSpecialistId ? movementSpecialistId : null,
    });
  }

  renderMapMarkerBubble = movementSpecialist => {
    return (
      <div key={movementSpecialist.id} className="map-marker__bubble">
        <div
          style={{ backgroundImage: `url(${movementSpecialist.profileImage.location})` }}
          className="map-marker__bubble__img"
        />
        <div className="map-marker__info">
          <h5>{movementSpecialist.name}</h5>
          <p>{movementSpecialist.location_short}</p>
          <span onClick={() => this.props.onClickViewProfile(movementSpecialist)}>View Profile</span>
        </div>
      </div>
    );
  };

  getMapMarkerBuilder(movementSpecialist) {
    return () => {
      const markerBubble =
        this.state.openBubbleMovementSpecialistId === movementSpecialist.id
          ? this.renderMapMarkerBubble(movementSpecialist)
          : null;

      const handleMarkerClick = e => {
        this.displayBubble(movementSpecialist.id);
        if (this.props.onClickMarker) {
          this.props.onClickMarker(movementSpecialist);
        }
      };

      return (
        <div key={movementSpecialist.id} onClick={handleMarkerClick}>
          <div className="map-marker">
            <Icon icon="MapMarker" size="large" color="dark" />
          </div>
          {markerBubble}
        </div>
      );
    };
  }

  handleMarkerEnter = () => {
    this.setState({ isMouseOnMarker: true });
  };

  handleMarkerLeave = () => {
    this.setState({ isMouseOnMarker: false });
  };

  handleMapClick = () => {
    if (!this.state.isMouseOnMarker) {
      this.setState({ openBubbleMovementSpecialistId: null });
    }
  };

  handleChange = values => {
    this.props.onChange(values.zoom, values.size);
  };

  render() {
    const { center, movementSpecialists, zoom } = this.props;

    const markers = movementSpecialists.map(ms => {
      const Marker = this.getMapMarkerBuilder(ms);

      return <Marker key={ms.id} lat={ms.latitude} lng={ms.longitude} />;
    });

    return (
      <div className="ms__map" onClick={this.handleMapClick}>
        <GoogleMapReact
          center={center}
          options={this.createMapOptions}
          zoom={zoom}
          onChildMouseEnter={this.handleMarkerEnter}
          onChildMouseLeave={this.handleMarkerLeave}
          onChange={this.handleChange}
        >
          {markers}
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/subscription/coaching/movement-specialists/GoogleMap.js